import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { SfContactResponse } from '../../api/get-sf-contact/getSfContact.types';

import { getSfContact } from '../../api/get-sf-contact/getSfContact';

export function useSfContact(
  sfMasterContactId: string,
  sfAccountId: string
): UseQueryResult<SfContactResponse, Error> {
  return useQuery<SfContactResponse, Error>({
    queryKey: ['sf-contact', sfMasterContactId, sfAccountId],
    queryFn: (): Promise<SfContactResponse> =>
      getSfContact(sfMasterContactId, sfAccountId),
    enabled: !!sfMasterContactId && !!sfAccountId,
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
